export default async (args = {}) => {
  const r = await axios.get('site/clientes'), carousel = [], names = []
  r.forEach(i => {
    carousel.push({
      image: 'src/fotos/clientes/' + i.image,
      actions: {
        color: "error darken-2",
        icon: "account-group",
        text: i.name,
        action: i.lnk
      }
    });
    names.push('<strong>' + i.name + '</strong>')
  });
  const total = names.length - 1, ultimo = names[total]
  delete names[total]
  const areas = names.join(", ") + ' e ' + ultimo;
  return {
    msg: `<div class="mb-2">Nossos principais clientes são ${areas}.</div>`,
    carousel
  }
}